import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

interface IRolesOptions {
  claimsCount: number;
  role: { id: number; name: string };
};

const initialState: any = {
  roles: null,
  roleRights: null,
  allRolesRights: null,
  rolesCount: null,
  limit: JSON.parse(localStorage.getItem("pageLimit") as string) || 10,
  page: 1,
  rolesStatus: null,
};

export const rolesSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    reducerRoles: (state: Draft<any>, action: PayloadAction<any>) => {
      state.roles = action.payload.sort((a: IRolesOptions, b: IRolesOptions) => a.role.name.localeCompare(b.role.name));
      state.rolesCount = Object.keys(action.payload).length;
    },
    reducerRolesRights: (state: Draft<any>, action: PayloadAction<any>) => {
      state.allRolesRights = action.payload.availableClaims;
      state.roleRights = action.payload.activeClaims;
    },
    reducerRolesStatus: (state: Draft<any>, action: PayloadAction<any>) => {
      state.rolesStatus = action.payload;
    },
    reducerRolesClear: () => {
      return initialState;
    },
  },
});

export const { reducerRolesRights, reducerRoles, reducerRolesClear, reducerRolesStatus } = rolesSlice.actions;

export default rolesSlice.reducer;
